import { jwtDecode } from 'jwt-decode'

const rolesHierarchy = [
  'content-manager',
  'internal',
  'admin',
  'organization',
  'institution-manager',
  'institution-owner',
  'institution',
  'teacher',
  'student',
  'anonymous',
]

const teacherRoles = rolesHierarchy.slice(0, 8)

const decodeToken = (token) => {
  return jwtDecode(token)
}

const findHighestRole = (decodedToken) => {
  return (
    rolesHierarchy.find((role) => decodedToken.roles.includes(role)) ||
    'anonymous'
  )
}

const determineUserRole = (highestUserRole) => {
  return highestUserRole === 'content-manager' ? 'content-manager' : teacherRoles.indexOf(highestUserRole) !== -1 ? 'teacher' : 'student'
}

export { rolesHierarchy, decodeToken, findHighestRole, determineUserRole }
